
// =================================================================================

export const SUPPORT_MAIL = 'support@talesup.io';
export const PURCHASES_AVAILABLE = true;
export const PURCHASES_AVAILABLE_TEST = false;

export const ONLINE_AVAILABLE = true;
